var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tip-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "tip-options" }, [
      _c(
        "div",
        {
          staticClass: "tip-card no-highlight",
          attrs: { tabindex: "0", "aria-label": "no tip" },
          on: {
            click: function($event) {
              return _vm.closeModal()
            },
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.closeModal()
            }
          }
        },
        [_c("span", [_vm._v("No tip")])]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tip-card no-highlight",
          attrs: { tabindex: "0", "aria-label": "ten percent tip" },
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.handleTipClick("small")
            },
            click: function($event) {
              return _vm.handleTipClick("small")
            }
          }
        },
        [
          _c("div", { staticClass: "tip-emoji" }, [_vm._v("💙")]),
          _vm._v(" "),
          _vm.abovePriceBoundary
            ? _c("div", { staticClass: "tip--amount small-tip" }, [
                _vm._v("10%")
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.abovePriceBoundary
            ? _c("div", { staticClass: "tip--amount small-tip" }, [
                _vm._v(_vm._s(_vm.smallTip()))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.abovePriceBoundary
            ? _c("div", { staticClass: "tip--actual-amount" }, [
                _vm._v(_vm._s(_vm.smallTip()))
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tip-card no-highlight",
          attrs: { tabindex: "0", "aria-label": "fifteen percent tip" },
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.handleTipClick("medium")
            },
            click: function($event) {
              return _vm.handleTipClick("medium")
            }
          }
        },
        [
          _c("div", { staticClass: "tip-emoji" }, [_vm._v("💕")]),
          _vm._v(" "),
          _vm.abovePriceBoundary
            ? _c("div", { staticClass: "tip--amount medium-tip" }, [
                _vm._v("15%")
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.abovePriceBoundary
            ? _c("div", { staticClass: "tip--amount medium-tip" }, [
                _vm._v(_vm._s(_vm.mediumTip()))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.abovePriceBoundary
            ? _c("div", { staticClass: "tip--actual-amount" }, [
                _vm._v(_vm._s(_vm.mediumTip()))
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tip-card no-highlight",
          attrs: { tabindex: "0", "aria-label": "twenty percent tip" },
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.handleTipClick("large")
            },
            click: function($event) {
              return _vm.handleTipClick("large")
            }
          }
        },
        [
          _c("div", { staticClass: "tip-emoji" }, [_vm._v("😍")]),
          _vm._v(" "),
          _vm.abovePriceBoundary
            ? _c("div", { staticClass: "tip--amount large-tip" }, [
                _vm._v("20%")
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.abovePriceBoundary
            ? _c("div", { staticClass: "tip--amount large-tip" }, [
                _vm._v(_vm._s(_vm.largeTip()))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.abovePriceBoundary
            ? _c("div", { staticClass: "tip--actual-amount" }, [
                _vm._v(_vm._s(_vm.largeTip()))
              ])
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h2", { staticClass: "heading--info", attrs: { tabindex: "0" } }, [
        _vm._v("\n\t\t\tTip the crew and send an Emoji?\n\t\t")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c3a7bbe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c3a7bbe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/Tips.vue
// module id = null
// module chunks = 